import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedModule } from '../../../../shared/shared.module';
import { IRetailPlace } from '../../../../core/modules/retail-places/retail-paces.types';
import { RetailPlacesApiService } from '../../../../core/modules/retail-places/retail-places-api.service';

@Component({
  selector: 'tax-retail-place-info',
  templateUrl: './retail-place-info.component.html',
  styleUrls: ['./retail-place-info.component.sass'],
  standalone: true,
  imports: [
    SharedModule,
  ],
})

export class RetailPlaceInfoComponent {
  @Input() set retailPlaceId(id: number) {
    this.retailPlace$ = this.retailPlaceApiService.fetchRetailPlace(id);
  }

  retailPlace$?: Observable<IRetailPlace>;

  constructor(private retailPlaceApiService: RetailPlacesApiService) {}
}
